export const COLORS = {
  danger: '#ff4d4f',
  disabled: '#d9d9d9',
  warning: '#FFBF00',
  success: '#52c41a',
  tags: {
    magenta: 'magenta',
    red: 'red',
    volcano: 'volcano',
    orange: 'orange',
    gold: 'gold',
    lime: 'lime',
    green: 'green',
    cyan: 'cyan',
    blue: 'blue',
    geekblue: 'geekblue',
    purple: 'purple',
    processing: 'processing',
    success: 'success',
    error: 'error',
    warning: 'warning',
    default: 'default',
  },
};
